/**
 * Venus Jewelry — Regalos automáticos por nivel ("El camino del regalo")
 *
 * Nivel 1 (5 charms)  → Charm Sorpresa: se agrega solo, sin popup.
 * Nivel 2 (7 charms)  → Pulsera Italiana: abre un popup para que la clienta
 *                       elija el color (solo modelos con existencia) y esa
 *                       elección se agrega al carrito. Se repite cada 7
 *                       charms (14 = 2 pulseras, 21 = 3, sin tope) — cada
 *                       vez que se desbloquea una más, se vuelve a preguntar.
 * Nivel 3 (8 charms)  → Herramienta: se agrega sola, sin popup.
 * Nivel 4 (10 charms) → Cubre Polvos + Bolsa: se agrega solo, sin popup.
 *
 * Precios: Shopify no deja aplicar 2 descuentos automáticos "Buy X Get Y"
 * a la vez en el mismo carrito (límite real de la plataforma — confirmado
 * probando en vivo, no era cosa de configuración). Por eso solo la Pulsera
 * (nivel 2) sigue usando un descuento automático de Shopify; Charm
 * Sorpresa se bajó a precio $0 directo, y Herramienta/Bolsa/cada color de
 * pulsera usan un producto "gemelo" a $0 (oculto, sin colección ni menú)
 * en vez del producto real que sí se vende aparte a precio normal — así
 * ningún regalo depende de, ni le pelea a otro por, un descuento activo.
 * Cada línea de regalo se marca con la propiedad `_regalo_nivel` para no
 * confundirla nunca con una compra real del mismo producto.
 */

(function () {
  var PROP_NAME = '_regalo_nivel';
  var FETCH_HEADERS = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  // ── Regalos de una sola vez que se agregan/quitan solos, sin popup ──
  // VJ: Shopify no aplica 2 descuentos automáticos "Buy X Get Y" a la vez
  // en el mismo carrito (límite real de la plataforma, confirmado
  // probando en vivo — no es cosa de combinesWith). Por eso estos 3 ya NO
  // dependen de ningún descuento: Charm Sorpresa se bajó a precio $0
  // directo, y Herramienta/Bolsa usan un producto "gemelo" a $0 (oculto,
  // sin colección ni menú) en vez del producto real que sí se vende
  // aparte — así ningún regalo pelea con otro por "el" descuento activo.
  var GIFTS = [
    { level: '1', name: 'Charm Sorpresa', variantId: 51697119690985, threshold: 5 },
    { level: '3', name: 'Herramienta (Regalo)', variantId: 51697640636649, threshold: 8 },
    { level: '4', name: 'Cubre Polvos + Bolsa (Regalo)', variantId: 51697641488617, threshold: 10 },
    // VJ: regalo por producto, no por charms — 1 por cada pieza con la etiqueta
    // "regalo-bolsa" (ej. pack Corazón), contada en Liquid (data-pack-gift-count).
    { level: 'pack', name: 'Cubre Polvos + Bolsa (Regalo pack)', variantId: 51697641488617, perPack: true },
    // VJ: igual, 1 Herramienta (gemelo a $0) por cada pieza con la etiqueta
    // "regalo-herramienta" (data-pack-tool-count). Línea aparte de la del nivel 3.
    { level: 'pack-tool', name: 'Herramienta (Regalo pack)', variantId: 51697640636649, perPack: true, countAttr: 'data-pack-tool-count' },
  ];

  var isSyncing = false;
  var pendingRecheck = false;
  // VJ: cuántos charms tenía el carrito la última vez que terminamos de
  // sincronizar regalos. Si el carrito cambia pero este número sigue igual,
  // no hay nada que ajustar — nos ahorramos el fetch a /cart.js. Sin esto,
  // cada cambio de cantidad disparaba una lectura de cart.js de más, y con
  // varios clics seguidos en +/- eso chocaba con el límite de requests de
  // Shopify ("demasiados intentos") y se sentía congelado.
  var lastSyncedCharmsCount = null;
  var debounceTimer = null;
  var DEBOUNCE_MS = 500;

  function charmsCountFromDOM() {
    var bar = document.getElementById('vj-journey-bar');
    if (!bar) return null;
    var raw = bar.getAttribute('data-charms-count');
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  function packGiftCountFromDOM(attr) {
    var bar = document.getElementById('vj-journey-bar');
    var n = bar ? parseInt(bar.getAttribute(attr || 'data-pack-gift-count'), 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  // Llave de todos los regalos por pack (bolsa y herramienta), para detectar cambios
  function packCountsKey() {
    return packGiftCountFromDOM('data-pack-gift-count') + ',' + packGiftCountFromDOM('data-pack-tool-count');
  }

  function desiredQtyFor(gift, charmsCount) {
    if (gift.perPack) return packGiftCountFromDOM(gift.countAttr);
    if (charmsCount === null || charmsCount < gift.threshold) return 0;
    return 1;
  }

  function findGiftLine(cart, gift) {
    return cart.items.find(function (item) {
      return item.variant_id === gift.variantId && item.properties && item.properties[PROP_NAME] === gift.level;
    });
  }

  // VJ: fetch() solo rechaza su promesa si hay una falla de RED — un 422
  // (ej. producto no publicado a la Tienda en línea, sin existencia, etc.)
  // se resuelve igual que un 200 y el código seguía de largo como si el
  // regalo sí se hubiera agregado. Este helper hace que un status no-ok sí
  // rompa la cadena, para que el error se vea en consola y no se marque
  // como sincronizado algo que en realidad falló.
  // VJ: todas las escrituras al carrito pasan por la cola global (scripts.liquid)
  // para no correr en paralelo con los cambios de cantidad de la clienta.
  function queued(fn) {
    return window.VJCartQueue ? window.VJCartQueue.run(fn) : fn();
  }

  function getCart() {
    return queued(function () {
      return fetch('/cart.js').then(function (r) {
        return r.json();
      });
    });
  }

  function postJSON(url, body) {
    return queued(function () {
      return fetch(url, { method: 'POST', headers: FETCH_HEADERS, body: JSON.stringify(body) });
    }).then(function (r) {
      if (!r.ok) {
        return r
          .json()
          .catch(function () {
            return {};
          })
          .then(function (errBody) {
            throw new Error('HTTP ' + r.status + ' en ' + url + ' — ' + JSON.stringify(errBody));
          });
      }
      return r.json();
    });
  }

  function announceCartUpdate(cart) {
    // VJ: un regalo que se agrega solo no debe abrir el carrito lateral (ej. al
    // agregar el pack con el botón sticky) — se quita auto-open un instante; el
    // listener que lo abre corre síncrono durante el dispatch.
    var drawer = document.querySelector('cart-drawer-component[auto-open]');
    if (drawer) drawer.removeAttribute('auto-open');
    // VJ: mismo evento que dispara el resto del tema (product-form-component,
    // cart-drawer, etc.) al agregar/cambiar algo — así el drawer, la página
    // de carrito y el contador del header se refrescan solos, sin duplicar
    // la lógica de morph/section-rendering que ya vive en component-cart-items.js.
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'venus-gift-milestones',
          data: { itemCount: cart.item_count },
        },
      })
    );
    if (drawer) drawer.setAttribute('auto-open', '');
  }

  // ════════════════════════════════════════════════════════════════════
  // Regalos de una sola vez (Sorpresa / Herramienta / Bolsa)
  // ════════════════════════════════════════════════════════════════════

  function syncOneTimeGifts(cart, charmsCount) {
    var changes = []; // { id: line key, quantity }
    var additions = []; // { id: variantId, quantity, properties }

    GIFTS.forEach(function (gift) {
      var desiredQty = desiredQtyFor(gift, charmsCount);
      var line = findGiftLine(cart, gift);
      var currentQty = line ? line.quantity : 0;

      if (desiredQty === currentQty) return;

      if (line) {
        changes.push({ id: line.key, quantity: desiredQty });
      } else if (desiredQty > 0) {
        var properties = {};
        properties[PROP_NAME] = gift.level;
        additions.push({ id: gift.variantId, quantity: desiredQty, properties: properties });
      }
    });

    if (changes.length === 0 && additions.length === 0) return Promise.resolve({ changed: false, hadError: false });


    // VJ: cada cambio/adición va en su PROPIA llamada — nunca varios items
    // juntos en un solo /cart/add.js. Shopify falla ese endpoint completo
    // (sin agregar NADA) si uno solo de los items no es válido (ej. un
    // producto no publicado a la Tienda en línea), así que agrupar el
    // Charm Sorpresa y la Herramienta en la misma llamada significaba que
    // un problema con uno tumbaba al otro también, aunque el otro sí fuera
    // perfectamente válido.
    var chain = Promise.resolve();
    var hadError = false;

    changes.forEach(function (change) {
      chain = chain.then(function () {
        return postJSON('/cart/change.js', change).catch(function (err) {
          hadError = true;
          console.warn('⚠️ [venus-gift-milestones] Falló actualizar la cantidad de un regalo:', change, err);
        });
      });
    });

    additions.forEach(function (addition) {
      chain = chain.then(function () {
        return postJSON('/cart/add.js', { items: [addition] }).catch(function (err) {
          hadError = true;
          console.warn('⚠️ [venus-gift-milestones] Falló agregar un regalo al carrito:', addition, err);
        });
      });
    });

    return chain.then(function () {
      return { changed: true, hadError: hadError };
    });
  }

  // ════════════════════════════════════════════════════════════════════
  // Popup "elige tu pulsera" (nivel 2 — 7 charms, se repite cada 7)
  // ════════════════════════════════════════════════════════════════════

  var braceletOptions = [];
  var braceletVariantIds = {}; // set: variantId -> true, para detectar líneas de regalo ya reclamadas
  var liveModal = null; // referencia al popup, una vez sacado del área que hace morph
  var dismissedForOwed = 0; // última cantidad "adeudada" que la clienta cerró sin elegir
  var braceletActionInFlight = false;

  function parseBraceletData() {
    var el = document.getElementById('vj-bracelet-data');
    if (!el) return;
    try {
      braceletOptions = JSON.parse(el.textContent) || [];
    } catch (err) {
      console.warn('⚠️ [venus-gift-milestones] No se pudo leer #vj-bracelet-data', err);
      braceletOptions = [];
    }
    braceletVariantIds = {};
    braceletOptions.forEach(function (opt) {
      braceletVariantIds[opt.variantId] = true;
    });
  }

  function braceletsOwed(charmsCount) {
    if (charmsCount === null || charmsCount < 7) return 0;
    return Math.floor(charmsCount / 7);
  }

  function braceletsClaimedFromCart(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (braceletVariantIds[item.variant_id] && item.properties && item.properties[PROP_NAME] === '2') {
        total += item.quantity;
      }
    });
    return total;
  }

  // VJ: el <div id="vj-bracelet-modal-source"> que arma Liquid vive DENTRO
  // de la sección del carrito, que se vuelve a renderizar (morph) en cada
  // cambio — si el popup interactivo viviera ahí, perdería su estado
  // (abierto/cerrado, contenido de la cuadrícula) a media elección. Por
  // eso la primera vez que aparece se saca al <body> y se vuelve la copia
  // "viva"; cualquier copia nueva que Liquid vuelva a renderizar después
  // se descarta de inmediato.
  function claimModalFromDOM() {
    var freshCopy = document.getElementById('vj-bracelet-modal-source');
    if (!freshCopy) return;

    if (!liveModal) {
      freshCopy.removeAttribute('id');
      freshCopy.id = 'vj-bracelet-modal';
      liveModal = freshCopy;
      mountModal();
      wireModalEvents(liveModal);
    } else {
      freshCopy.remove();
    }
  }

  // VJ: el drawer se abre con showModal() — queda en el "top layer" y deja
  // inerte todo lo que está fuera de él. Si el popup viviera en <body>
  // mientras el drawer está abierto, quedaría DETRÁS y sin poder tocarse.
  // Por eso se monta dentro del drawer (en .vj-drawer-overlays, que el morph
  // no toca) cuando está abierto, y en <body> cuando está cerrado.
  function mountModal() {
    if (!liveModal) return;
    var drawer = document.querySelector('dialog.cart-drawer__dialog');
    var overlays = drawer && drawer.open ? drawer.querySelector('.vj-drawer-overlays') : null;
    var target = overlays || document.body;
    if (liveModal.parentNode !== target) target.appendChild(liveModal);
  }

  var lastFocusBeforeModal = null;

  function wireModalEvents(modal) {
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-vj-bracelet-close]')) {
        userDismissModal();
      }
    });
    // Captura en window: Escape cierra SOLO el popup, sin cerrar también el drawer.
    window.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          userDismissModal();
        }
      },
      true
    );
    var drawer = document.querySelector('dialog.cart-drawer__dialog');
    if (drawer) drawer.addEventListener('close', mountModal);
    document.addEventListener('cart:open', mountModal);

    var grid = modal.querySelector('#vj-bracelet-modal-grid');
    if (grid) {
      grid.addEventListener('click', function (e) {
        var btn = e.target.closest('.vj-bracelet-modal__option');
        if (!btn || btn.disabled) return;
        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!isNaN(variantId)) selectBracelet(variantId);
      });
    }
  }

  function setGridDisabled(disabled) {
    if (!liveModal) return;
    var buttons = liveModal.querySelectorAll('.vj-bracelet-modal__option');
    buttons.forEach(function (btn) {
      btn.disabled = disabled;
      btn.classList.toggle('is-loading', disabled);
    });
  }

  function renderBraceletGrid(remaining) {
    if (!liveModal) return;
    var grid = liveModal.querySelector('#vj-bracelet-modal-grid');
    var emptyMsg = liveModal.querySelector('#vj-bracelet-modal-empty');
    var subtitle = liveModal.querySelector('#vj-bracelet-modal-subtitle');

    if (subtitle) {
      subtitle.textContent =
        remaining > 1 ? 'Te faltan ' + remaining + ' pulseras gratis por elegir' : 'Selecciona el color que más te guste';
    }

    var available = braceletOptions.filter(function (opt) {
      return opt.available;
    });

    if (!grid) return;
    grid.innerHTML = '';

    if (available.length === 0) {
      if (emptyMsg) emptyMsg.hidden = false;
      return;
    }
    if (emptyMsg) emptyMsg.hidden = true;

    available.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vj-bracelet-modal__option';
      btn.setAttribute('data-variant-id', String(opt.variantId));

      var imageWrap = document.createElement('span');
      imageWrap.className = 'vj-bracelet-modal__option-image';
      var img = document.createElement('img');
      img.src = opt.image;
      img.alt = opt.title;
      img.loading = 'lazy';
      imageWrap.appendChild(img);

      var titleEl = document.createElement('span');
      titleEl.className = 'vj-bracelet-modal__option-title';
      titleEl.textContent = opt.title;

      var priceEl = document.createElement('span');
      priceEl.className = 'vj-bracelet-modal__option-price';
      var s = document.createElement('s');
      s.textContent = opt.price;
      var strong = document.createElement('strong');
      strong.textContent = ' GRATIS';
      priceEl.appendChild(s);
      priceEl.appendChild(strong);

      btn.appendChild(imageWrap);
      btn.appendChild(titleEl);
      btn.appendChild(priceEl);
      grid.appendChild(btn);
    });
  }

  function openModal(owed, claimed) {
    claimModalFromDOM();
    if (!liveModal) return;
    mountModal();
    renderBraceletGrid(owed - claimed);
    setGridDisabled(false);
    var wasOpen = liveModal.classList.contains('is-open');
    liveModal.classList.add('is-open');
    liveModal.setAttribute('aria-hidden', 'false');
    if (!wasOpen) {
      lastFocusBeforeModal = document.activeElement;
      var panel = liveModal.querySelector('.vj-bracelet-modal__panel');
      if (panel) {
        panel.setAttribute('tabindex', '-1');
        panel.focus({ preventScroll: true });
      }
    }
  }

  function closeModalSilently() {
    if (!liveModal) return;
    var wasOpen = liveModal.classList.contains('is-open');
    liveModal.classList.remove('is-open');
    liveModal.setAttribute('aria-hidden', 'true');
    if (wasOpen && lastFocusBeforeModal && document.contains(lastFocusBeforeModal)) {
      lastFocusBeforeModal.focus({ preventScroll: true });
    }
    lastFocusBeforeModal = null;
  }

  function userDismissModal() {
    dismissedForOwed = lastKnownOwed;
    closeModalSilently();
  }

  var lastKnownOwed = 0;

  function selectBracelet(variantId) {
    if (braceletActionInFlight) return;
    braceletActionInFlight = true;
    setGridDisabled(true);

    var properties = {};
    properties[PROP_NAME] = '2';

    postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: properties }] })
      .then(function () {
        return getCart();
      })
      .then(function (cart) {
        announceCartUpdate(cart);
        lastSyncedCharmsCount = charmsCountFromDOM() + '|' + packCountsKey(); // esto no cambia charms ni packs
        evaluateBraceletModal(cart);
      })
      .catch(function (err) {
        console.warn('⚠️ [venus-gift-milestones] Error agregando la pulsera elegida:', err);
      })
      .finally(function () {
        braceletActionInFlight = false;
        setGridDisabled(false);
      });
  }

  function trimBraceletGiftLines(cart, excess) {
    var giftLines = cart.items.filter(function (item) {
      return braceletVariantIds[item.variant_id] && item.properties && item.properties[PROP_NAME] === '2';
    });
    // Recortar empezando por las líneas agregadas más recientemente.
    giftLines.reverse();

    var toRemove = excess;
    var ops = [];
    giftLines.forEach(function (line) {
      if (toRemove <= 0) return;
      var reduceBy = Math.min(line.quantity, toRemove);
      ops.push({ id: line.key, quantity: line.quantity - reduceBy });
      toRemove -= reduceBy;
    });

    if (ops.length === 0) return;


    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () {
        return postJSON('/cart/change.js', op).catch(function (err) {
          console.warn('⚠️ [venus-gift-milestones] Falló quitar una pulsera de regalo sobrante:', op, err);
        });
      });
    });
    chain
      .then(function () {
        return getCart();
      })
      .then(function (updatedCart) {
        announceCartUpdate(updatedCart);
      });
  }

  function evaluateBraceletModal(cart) {
    var charmsCount = charmsCountFromDOM();
    if (charmsCount === null) {
      closeModalSilently();
      return;
    }

    var owed = braceletsOwed(charmsCount);
    var claimed = braceletsClaimedFromCart(cart);
    lastKnownOwed = owed;

    if (claimed > owed) {
      trimBraceletGiftLines(cart, claimed - owed);
      return;
    }

    if (owed > claimed) {
      if (owed > dismissedForOwed) {
        openModal(owed, claimed);
      }
    } else {
      closeModalSilently();
    }
  }

  // Reabrir manualmente el popup haciendo clic en el nodo "Pulsera" de la
  // barra, por si la clienta lo cerró sin elegir y quiere volver a verlo.
  document.addEventListener('click', function (e) {
    var node = e.target.closest('.vj-journey-node[data-node="2"]');
    if (!node) return;
    getCart()
      .then(function (cart) {
        var charmsCount = charmsCountFromDOM();
        var owed = braceletsOwed(charmsCount);
        var claimed = braceletsClaimedFromCart(cart);
        if (owed > claimed) {
          dismissedForOwed = 0; // reapertura manual: ignorar el "ya lo cerré"
          openModal(owed, claimed);
        }
      });
  });

  // ════════════════════════════════════════════════════════════════════
  // Orquestación: un solo fetch de /cart.js por ciclo para ambas cosas
  // ════════════════════════════════════════════════════════════════════

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      maybeSyncGifts();
    }, DEBOUNCE_MS);
  }

  function maybeSyncGifts() {
    claimModalFromDOM(); // por si esta sección se acaba de renderizar por primera vez

    var charmsCount = charmsCountFromDOM();

    if (charmsCount === null) {
      lastSyncedCharmsCount = null;
      closeModalSilently();
      return;
    }

    // VJ: la llave incluye cuántos packs con regalo hay, no solo los charms.
    var syncKey = charmsCount + '|' + packCountsKey();
    if (syncKey === lastSyncedCharmsCount) {
      return; // ya está sincronizado para estos charms y packs, sin red
    }

    syncGifts(charmsCount, syncKey);
  }

  function syncGifts(charmsCount, syncKey) {
    if (isSyncing) {
      pendingRecheck = true;
      return;
    }
    isSyncing = true;

    var hadErrorOuter = false;

    getCart()
      .then(function (cart) {
        return syncOneTimeGifts(cart, charmsCount).then(function (result) {
          hadErrorOuter = result.hadError;
          if (!result.changed) {
            evaluateBraceletModal(cart);
            return;
          }
          // Se agregó/quitó algo (o al menos se intentó) — releer el
          // carrito ya actualizado antes de anunciar el cambio y evaluar
          // el popup de la pulsera.
          return getCart()
            .then(function (freshCart) {
              announceCartUpdate(freshCart);
              evaluateBraceletModal(freshCart);
            });
        });
      })
      .then(function () {
        if (hadErrorOuter) {
          // No lo marcamos como sincronizado: así, aunque charmsCount no
          // vuelva a cambiar, el próximo cart:html-updated reintentará en
          // vez de quedarse "atorado" pensando que ya no hay nada pendiente.
          console.warn('⚠️ [venus-gift-milestones] Sync con errores — se reintentará en el próximo cambio del carrito.');
          return;
        }
        lastSyncedCharmsCount = syncKey;
      })
      .catch(function (err) {
        console.warn('⚠️ [venus-gift-milestones] Error sincronizando regalos:', err);
      })
      .finally(function () {
        isSyncing = false;
        if (pendingRecheck) {
          pendingRecheck = false;
          maybeSyncGifts();
        }
      });
  }

  // ── Verificar en cuanto carga la página (por si ya hay charms en el carrito) ──
  function init() {
    parseBraceletData();
    maybeSyncGifts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ── Re-verificar cada vez que el carrito cambia ──
  // cart:html-updated se dispara DESPUÉS de que la sección del carrito ya
  // se re-renderizó (morph), así que data-charms-count y #vj-bracelet-data
  // ya están actualizados. Se agrupa con debounce porque un solo clic en
  // +/- puede disparar este evento más de una vez.
  document.addEventListener('cart:html-updated', function () {
    parseBraceletData(); // el stock pudo haber cambiado
    scheduleSync();
  });

  // ── Red de seguridad ──
  // Si un intento anterior falló (ej. problema de red momentáneo), esto no
  // deja el regalo "atorado" hasta que la clienta vuelva a tocar el
  // carrito: cada 20s se reintenta. Con el caché de lastSyncedCharmsCount,
  // cuando ya todo está al día esto no dispara ningún request de más —
  // mismo patrón de polling ligero que ya usa charms-sticky-cart.liquid
  // en este tema.
  setInterval(maybeSyncGifts, 20000);

})();
